import React from "react"
import LinkButton from "@components/common/LinkButton"
import CollectionSwiper from "./Carousel/CollectionSwiper"
import { ArrowRight } from "@phosphor-icons/react"

const CollectionSection = ({featuredCollections}) => {

    return (
        <React.Fragment>
            <section className="max-container gap-y-8">
                <section className="flex flex-wrap justify-between items-start gap-x-6 flex-col md:flex-row">
                    <div>
                        <h1>Collections</h1>
                        <p className="mb-4">
                            Explore our latest swimwear, crafted for comfort and style. 
                        </p>
                    </div>

                    {/*<LinkButton
                        label={"Explore collections"}
                        className={'underline-on-hover'}
                        icon={<ArrowRight size={20} weight="light" />}
                        to="/collections"
                    />*/}
                </section>

                <div className="">
                    <CollectionSwiper
                        products={featuredCollections}
                        cardType="display card"
                        cardStyles={"collection-container-width"}
                        spaceBetween={10}
                        slidesPerView={5}
                        breakpoints={{// value of key is min-width property
                            300: {
                                slidesPerView: 2,
                                spaceBetween: 5,
                            },
                            500: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            640: {
                                slidesPerView: 3,
                            },
                            900: {
                                slidesPerView: 4,
                            },
                            1024: {
                                slidesPerView: 4,
                            },
                            1280: {
                                slidesPerView: 5,
                            },
                            1440: {
                                slidesPerView: 5,
                            },
                        }}
                        loop
                    />
                </div>
            </section>
        </React.Fragment>
  );
}

export default CollectionSection